import { z } from 'zod';
import {
  SearchFilterConfigType,
  TextFilterMatch,
} from '@agilelab/plugin-wb-search-common';

const SearchFilterTypeValidator = z.nativeEnum(SearchFilterConfigType);

const TextFilterMatchValidator = z.nativeEnum(TextFilterMatch);
const SearchFilterValidator = z
  .object({
    field: z.string().min(1),
    label: z.string().min(1).optional(),
    type: SearchFilterTypeValidator.optional(),
    defaultValues: z.array(z.string()).optional(),
    landscapes: z.array(z.string().min(1)).optional(),
    displayLabel: z.string().min(1).optional(),
    match: TextFilterMatchValidator.optional(),
  })
  .strict()
  .superRefine((filter, ctx) => {
    if (filter.match && filter.type !== 'text') {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Text match is only supported for text filters',
        path: ['match'],
      });
    }
  });

export const MarketplaceProjectsFiltersValidator = z
  .array(SearchFilterValidator)
  .superRefine((filters, ctx) => {
    const fields = new Set<string>();
    const labels = new Set<string>();

    filters.forEach((filter, index) => {
      if (fields.has(filter.field)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Duplicate field in filters: ${filter.field}`,
          path: [index, 'field'],
        });
      }
      if (filter.label && labels.has(filter.label)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Duplicate label in filters: ${filter.label}`,
          path: [index, 'label'],
        });
      }
      fields.add(filter.field);
      if (filter.label) labels.add(filter.label);
    });
  });

export type MarketplaceProjectsFiltersConfig = z.infer<
  typeof MarketplaceProjectsFiltersValidator
>;

export const validateSearchFilters = (filters: unknown) =>
  MarketplaceProjectsFiltersValidator.parse(filters);
